import { TimelineResolution } from "../TimelineResolution";

export class ForwardRequestDto {
	public DateResolution: TimelineResolution;
	public Start: Date;
	public End: Date;
	
	constructor(public ContractId: string, public FromResourceId: string, public ToResourceId?: string) { }
}